/**
 * av-object.js
 * Smooth-scrolls The Object CTA to the first Ascari Variant Selector on the
 * page. The behavior is section-scoped and respects reduced motion.
 */
(function () {
  var initialized = new WeakSet();

  function initObjectSection(section) {
    if (!section || initialized.has(section)) return;
    initialized.add(section);

    var button = section.querySelector('[data-av-scroll-target]');
    if (!button) return;

    button.addEventListener('click', function (event) {
      var selector = button.dataset.avScrollTarget;
      var target = selector ? document.querySelector(selector) : null;
      if (!target) return;

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      event.preventDefault();
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.av-object').forEach(initObjectSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
